import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { logger } from '../../utils/logger';

const useToastDismiss = (deps = []) => {
  const location = useLocation();
  logger.log('location', location);
  useEffect(() => {
    toast.dismiss();
  }, [location.pathname, location.search, location.state, ...deps]);
};

export default useToastDismiss;
